import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { NotFoundErrorPage } from 'src/pages/not-found';
import type { RouteProps } from 'src/types/router';

export const NOT_FOUND_ROUTE: RouteProps = {
  path: '*',
  element: <NotFoundErrorPage />,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
